import { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';

export const useIsMobile = () => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  return { isMobile };
};
